import { BaseError } from './base.js';
export class UrlRequiredError extends BaseError {
    constructor() {
        super('No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.', {
            name: 'UrlRequiredError',
        });
    }
}
export class TransportMethodNotSupportedError extends BaseError {
    constructor({ method }) {
        super(`No transport found that supports the method: ${method}`, {
            name: 'TransportMethodNotSupportedError',
        });
    }
}
export class AllTransportsFailedError extends BaseError {
    constructor({ method, params, errors, totalAttempts, }) {
        const errorMessages = errors
            .map(({ transport, error, attempt }) => `${attempt}. ${transport}: ${error.message}`)
            .join('\n');
        super(`All ${totalAttempts} transports failed for method "${method}": \n${errorMessages}`, {
            name: 'AllTransportsFailedError',
            metaMessages: [
                `Method: ${method}`,
                `Total attempts: ${totalAttempts}`,
                `Failed transports: ${errors.map((e) => e.transport).join(', ')}`,
            ],
        });
        this.method = method;
        this.params = params;
        this.errors = errors;
        this.totalAttempts = totalAttempts;
    }
}
//# sourceMappingURL=transport.js.map